import { ContactPage } from "../components"

export default ContactPage
